import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const TimeSheetSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'timesheets.settings.time_registration_mode_title',
            scope: 'division',
            explanationText: 'timesheets.settings.time_registration_mode_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'job_time_registration_mode',
                    buttonSize: 'large',
                    options: [
                        { value: 'start-end', name: 'job.settings.start_end_time_option' },
                        { value: 'duration', name: 'job.settings.duration_option' },
                    ]
                }
            ]
        },
        {
            title: 'timesheets.settings.office_time_tracking_title',
            scope: 'division',
            explanationText: 'timesheets.settings.office_time_tracking_explanation',
            switchButton: {
                enabled: true,
                name: 'office_time_tracking',
            }
        },
        {
            title: 'timesheets.settings.mobile_timesheets_title',
            scope: 'division',
            explanationText: 'timesheets.settings.mobile_timesheets_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_timesheets',
            }
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default TimeSheetSettings;